import flatpickr from 'flatpickr';
import { Finnish } from 'flatpickr/dist/l10n/fi';
import { Swedish } from 'flatpickr/dist/l10n/sv';
import UAParser from 'ua-parser-js';

const browserLang = document.documentElement.lang;

/**
 * Get flatpickr default config
 *
 * @param {string} type 'date' || 'datetime'
 * @returns {Object} config object for flatpickr
 */
function getDefaultConfig(type) {
  const parser = new UAParser();
  const browser = parser.getBrowser();

  let disableMobile = false;

  // Older Mobile Safari has problems with input `datetime-local` fields that don't have values.
  // https://stackoverflow.com/questions/43596201/ios-datetime-inputs-always-considered-invalid
  // https://stackoverflow.com/questions/43747521/mobile-safari-10-3-1-datetime-local-enter-a-valid-value-error
  // Disable native datetime picker for Mobile Safari <= 13
  if (type === 'datetime' && browser && browser.name === 'Mobile Safari') {
    const major = browser.version.split('.')[0];
    if (major <= 13) {
      disableMobile = true;
    }
  }

  const defaultConfig = {
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: 'd.m.Y',
    time_24hr: true,
    firstDayOfWeek: 1,
    disableMobile
  }

  if(browserLang === 'fi') {
    flatpickr.localize(Finnish);
    defaultConfig.locale = Finnish;
  } else if(browserLang === 'sv') {
    flatpickr.localize(Swedish);
    defaultConfig.locale = Swedish;
  }

  if(type === 'datetime') {
    defaultConfig.enableTime = true;
    defaultConfig.dateFormat = 'Y-m-d H:i';
    defaultConfig.altFormat = 'd.m.Y H:i';
  }

  return defaultConfig;
}
const datepicker = (selector, config = {}) => {
  const defaultConfig = getDefaultConfig();
  const settings = Object.assign(defaultConfig, config);

  return flatpickr(selector, settings);
}

const datetimepicker = (selector, config = {}) => {
  const defaultConfig = getDefaultConfig('datetime');
  const settings = Object.assign(defaultConfig, config);

  return flatpickr(selector, settings);
}

export default datepicker;
export { datepicker, datetimepicker, getDefaultConfig };
